import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-api-segregation',
  templateUrl: './api-segregation.component.html' 
})
export class ApiSegregationComponent implements OnInit {

  constructor(public router: Router) {

    localStorage.setItem("is_cuurent_nav_aem","n");
   }

  ngOnInit(): void {
  }

  patientaccess(){
    localStorage.setItem("viewAccess", "patientaccess");
    localStorage.setItem("viewAccessSec", "$process-message");
    this.router.navigate(['apis']);
  }

  providerDirectoryApi(){
    localStorage.setItem("viewAccess", "providerdirectory");
    localStorage.setItem("viewAccessSec", "providerdirectory");
    this.router.navigate(['apis']);
  }


  ProviderAccessApi(){
    localStorage.setItem("viewAccess", "provideraccess");
    localStorage.setItem("viewAccessSec", "cdshooks");
    this.router.navigate(['apis']);
  }

}
